import ContingencyTierOverviewSection from "@pallet/features/ApplylistType/components/PartnershipTierOverviewSection/variants/Contingency"
import ContingencyTierFeaturesSection from "@pallet/features/ApplylistType/components/PartnershipTierFeaturesSection/variants/Contingency"
import { ContingencyTierSelectorItem_applylist } from "__generated__/ContingencyTierSelectorItem_applylist"
import { ContingencySalesButton } from "@pallet/features/ApplylistType/components/ContingencyTierCta"

type ContingencyTierSelectorItemProps = {
    applylist: ContingencyTierSelectorItem_applylist
}

export const ContingencyTierSelectorItem = ({
    applylist,
}: ContingencyTierSelectorItemProps) => {
    return (
        <>
            <ContingencyTierOverviewSection
                cta={<ContingencySalesButton applylist={applylist} />}
            />
            <ContingencyTierFeaturesSection />
        </>
    )
}
